import { callExternalApi } from './external-api.service'
import OB_API_PATHS from '../constants/OB_API_PATHS';

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

export const generateFetchHeaders = (auth0Token, token = '') => {
    const fetchHeaders = {
        "Finicity-App-Key": "appKey",
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${auth0Token}`,
    };

    if (token) {
        fetchHeaders["Finicity-App-Token"] = token;
    }

    return fetchHeaders
};

export const svc_ob_genToken = async (auth0Token) => {
    const headers = generateFetchHeaders(auth0Token);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GEN_TOKEN()}`,
        data: {
            partnerId: 'partnerId',
            partnerSecret: 'partnerSecret',
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_addTestCustomer = async (auth0Token, appToken, username) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.ADD_TEST_CUSTOMER()}`,
        data: {
            username,
            firstName: 'fastBasslance',
            lastName: 'TestingM122arch12',
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_addCustomer = async (auth0Token, appToken, customerId) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.ADD_CUSTOMER()}`,
        data: {
            customerId,
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_genConnectURL = async (auth0Token, appToken, customerId) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GEN_CONNECT_URL()}`,
        data: {
            customerId,
            partnerId: "partnerId",
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_getCustomerAccounts = async (auth0Token, appToken, customerId) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GET_CUSTOMER_ACCOUNTS(customerId)}`,
        method: 'GET',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_refreshCustomerAccounts = async (auth0Token, appToken, customerId) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GET_CUSTOMER_ACCOUNTS(customerId)}`,
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_getCustomerTransactions = async (auth0Token, appToken, customerId, params) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GET_CUSTOMER_TRANSACTIONS(customerId, params)}`,
        method: 'GET',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_getCustomerAccountTransactions = async (auth0Token, appToken, customerId, accountId, params) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GET_CUSTOMER_ACCOUNT_TRANSACTIONS(customerId, accountId, params)}`,
        method: 'GET',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_ob_getInstitutionById = async (auth0Token, appToken, institutionId) => {
    const headers = generateFetchHeaders(auth0Token, appToken);
    const config = {
        url: `${apiServerUrl}${OB_API_PATHS.GET_INSTITUTION_BY_ID(institutionId)}`,
        method: 'GET',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}